import { Box, Grid, Typography, useTheme } from "@mui/material";
import React from "react";
import CarTagView from "../../../../components/CarTag";
import profileImage from "../../../../../media/images/profileImage.png";
import CarTimerIcon from "../../../../../media/images/icons/car-timer";
import UserInfo from "./UserInfo";
import BoxSearchIcon from "../../../../../media/images/icons/box-search";
import CustomAutoComple from "../../../../components/CustomAutoComplete";
import SearchBox from "./SearchBox";
import SideContent from "./SideContent";

export default function MainContent() {
  const theme = useTheme();
  return (
    <Box
      sx={{
        flex: 1,
        // border: "1px solid gray",
        // height: "30px",
        marginTop: "70px",
        overflow: "auto",
        paddingY: "8px",
      }}
    >
      <UserInfo />
      <Box
        sx={{
          width: "100%",
          display: "flex",
          gap: "8px",
        }}
      >
        <Grid
          sx={{
            mt: 3,
            display: "felx",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          container
        >
          <Grid item xs={8.25}>
            <SearchBox />
          </Grid>
          <Grid item xs={3.5}>
            <SideContent />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
